__turbopack_context__.v({
  "Row": "Forms-module__vUHMtW__Row",
  "Subtitle": "Forms-module__vUHMtW__Subtitle",
  "activeForm": "Forms-module__vUHMtW__activeForm",
  "errorMessage": "Forms-module__vUHMtW__errorMessage",
  "fadeIn": "Forms-module__vUHMtW__fadeIn",
  "fadeOut": "Forms-module__vUHMtW__fadeOut",
  "focused": "Forms-module__vUHMtW__focused",
  "formEvanhub": "Forms-module__vUHMtW__formEvanhub",
  "innerForm": "Forms-module__vUHMtW__innerForm",
  "inputError": "Forms-module__vUHMtW__inputError",
  "input_flag": "Forms-module__vUHMtW__input_flag",
  "isNoValidate": "Forms-module__vUHMtW__isNoValidate",
  "isValidate": "Forms-module__vUHMtW__isValidate",
  "loader": "Forms-module__vUHMtW__loader",
  "messageForm": "Forms-module__vUHMtW__messageForm",
  "phone_label": "Forms-module__vUHMtW__phone_label",
  "prixClipFix": "Forms-module__vUHMtW__prixClipFix",
  "rotate": "Forms-module__vUHMtW__rotate",
  "successMessage": "Forms-module__vUHMtW__successMessage",
});
